import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IGlobalPartner } from '../models/globalPartner'

export const getJbpGlobalPartnerAdministrationCrud = () => {
  return CrudStore.get(CrudStoreItemPartner360.JBPGlobalPartnerTableData) as Crud<IGlobalPartner>
}
